import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateOrderStatus } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useUpdateOrderStatus() {
  const queryClient = useQueryClient()
  const { accessToken } = useAuthStore()

  return useMutation({
    mutationFn: async ({
      orderId,
      status,
    }: {
      orderId: string
      status: "PENDING" | "ACCEPTED" | "APPROVED" | "REJECTED" | "IN_PRODUCTION" | "IN_TRANSIT" | "COMPLETED" | "CANCELLED"
    }) => {
      if (!accessToken) throw new Error("No token available")
      return updateOrderStatus(orderId, status, accessToken)
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin-orders"] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", variables.orderId] })
    },
    onError: (error: any) => {
      console.error("Failed to update order status:", error)
    },
  })
}
